import { render } from "./AccountConfigPanel.vue?vue&type=template&id=b54cafce"
import script from "./AccountConfigPanel.vue?vue&type=script&lang=js"
export * from "./AccountConfigPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__